// extracted by mini-css-extract-plugin
export default {"container":"container_K4Q0U","inner":"inner_tGFwb","avatar":"avatar_itRrA","textContent":"textContent_aGYn_","button":"button_mETkL"};